module.exports = __webpack_public_path__ + "img/smo.a20a7f26.jpg";